import React, { useEffect, useState } from 'react'
import { FaChevronCircleLeft, FaPlus } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import { DefaultMoughataaInterface, ShowMoughataaContext, moughataaInterface } from './types'
import DataddMoughataa from './DataMoughataa'
import { useDispatch } from 'react-redux'
import SuccessMsg from '../../Messages/SuccessMsg'
import DeletedMoughataa from './DeleteMoughataa'
import { getMoughataasApi } from '../../redux/moughataas/moughataaApiCalls'
import UpdateMoughataa from './UpdateMoughataa'
import CreateMoughataa from './CreateMoughataa'

const ShowMoughataa = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedMoughataa, setSelectedMoughataa] = useState<moughataaInterface>(DefaultMoughataaInterface)
  
  const navigate = useNavigate()

  const dispatch: any = useDispatch()

  useEffect(() => {
    const fetchAPIs = async () => {
      await dispatch(getMoughataasApi())
    }
    fetchAPIs()
  }, [dispatch])

  return (
    <ShowMoughataaContext.Provider value={{ 
      showSuccessMsg, setShowSuccessMsg,
      showAddModal, setShowAddModal,
      showEditModal, setShowEditModal,
      showDeleteModal, setShowDeleteModal,
      selectedMoughataa, setSelectedMoughataa,
     }}>

      <SuccessMsg modal={showSuccessMsg} toggle={() => setShowSuccessMsg(!showSuccessMsg)} />

      <div className="flex justify-start gap-2">
        <FaChevronCircleLeft style={{ fontSize: "30px" }} className="text-main" onClick={() => navigate("/")}/>
        <button className="p-2 rounded btn-main" onClick={() => setShowAddModal(!showAddModal)}>
          <FaPlus />
        </button>
      </div>

      <DataddMoughataa />
      {showAddModal && <CreateMoughataa modal={showAddModal} toggle={() => setShowAddModal(!showAddModal)} />}
      {showEditModal && <UpdateMoughataa modal={showEditModal} toggle={() => setShowEditModal(!showEditModal)} />}
      {showDeleteModal && <DeletedMoughataa modal={showDeleteModal} toggle={() => setShowDeleteModal(!showDeleteModal)} />}

    </ShowMoughataaContext.Provider>
  )
}

export default ShowMoughataa